import { render } from "./appsidebar.vue?vue&type=template&id=e2adfb5c&scoped=true"
import script from "./appsidebar.vue?vue&type=script&lang=js"
export * from "./appsidebar.vue?vue&type=script&lang=js"

import "./appsidebar.vue?vue&type=style&index=0&id=e2adfb5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2adfb5c"]])

export default __exports__